document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();

          this.form = this.querySelector('form');
          if (this.variantIdInput) {
            this.variantIdInput.disabled = false;
          }
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton.querySelector('span');

          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

          this.hideErrors = this.dataset.hideErrors === 'true';
        }

        onSubmitHandler(evt) {
          evt.preventDefault();
          console.log('ProductForm: Submit handler triggered');

          // if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          //   console.log('ProductForm: Button is disabled, aborting');
          //   return;
          // }

          this.handleErrorMessage();

          // this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          // Wrap setup logic in try-catch to prevent silent crashes keeping button disabled
          try {
            // Retry finding cart element if missing
            if (!this.cart) {
              this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
              if (this.cart) console.log('ProductForm: Found cart component on retry');
            }

            // Validate cart component readiness
            if (this.cart && typeof this.cart.getSectionsToRender !== 'function') {
              console.warn('ProductForm: Cart component found but not ready (no getSectionsToRender). Treating as missing.');
              this.cart = null;
            }

            const formData = new FormData(this.form);
            if (this.cart) {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            } else {
              console.log('ProductForm: No cart element found (cart-notification/cart-drawer)');
            }
            config.body = formData;
          } catch (err) {
            console.error('ProductForm: Error preparing request', err);
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.submitButton.removeAttribute('aria-disabled');
            return;
          }

          console.log('ProductForm: Fetching cart add...');
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              console.log('ProductForm: Response received', response);
              if (response.status) {
                console.log('ProductForm: Response has status (Error)', response.status);
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) {
                  this.submitButton.removeAttribute('aria-disabled');
                  this.error = true;
                  return;
                }
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                console.log('ProductForm: No cart component, redirecting to cart url');
                window.location = window.routes.cart_url;
                return;
              }

              console.log('ProductForm: Success. Updating cart.');
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                        if (this.cart && typeof this.cart.open === 'function') this.cart.open();
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  console.log('ProductForm: Calling cart.renderContents');
                  this.cart.renderContents(response);
                  if (this.cart && typeof this.cart.open === 'function') this.cart.open();
                });
              }
            })
            .catch((e) => {
              console.error('ProductForm: Fetch Error', e);
            })
            .finally(() => {
              console.log('ProductForm: Finally block. Error state:', this.error);
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

              // FORCE RE-ENABLE regardless of error state if it's not a Sold Out persistence case
              // logic above sets this.error=true for SoldOut (but only if soldOutMessage exists)
              // If there's no error, we re-enable.
              if (!this.error) {
                this.submitButton.removeAttribute('aria-disabled');
                console.log('ProductForm: Button re-enabled');
              } else {
                // Check if it was the "missing sold out message" case which returns early? No
                // If this.error is true, we leave it disabled?
                // Wait, for standard API errors (like "You can't add more of this item"), we SHOULD re-enable the button so they can fix it.
                // Only "Sold Out" (aka max quantity reached?) should disable?
                // Actually, usually standard errors should NOT permanently disable the button.
                // Let's relax this:
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage || soldOutMessage.classList.contains('hidden')) {
                  this.submitButton.removeAttribute('aria-disabled');
                  console.log('ProductForm: Button re-enabled (Force)');
                }
              }

              this.querySelector('.loading__spinner').classList.add('hidden');

              CartPerformance.measureFromEvent("add:user-action", evt);
            });
        }

        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;

          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }

        toggleSubmitButton(disable = true, text) {
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text) this.submitButtonText.textContent = text;
          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }

        get variantIdInput() {
          return this.form.querySelector('[name=id]');
        }
      }
    );
  }
})